import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@blueprintjs/core";
import classNames from "classnames";
export default ({ steps, ...rest }) => /* @__PURE__ */ jsx("div", { style: { display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ jsx("ul", { className: "bp3-breadcrumbs", ...rest, children: steps.map(({ completed, active, text }, i) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
  "div",
  {
    className: classNames("bp3-breadcrumb", {
      "bp3-breadcrumb-current": active
    }),
    children: [
      /* @__PURE__ */ jsx(Icon, { icon: completed ? "tick-circle" : void 0 }),
      text
    ]
  }
) }, i)) }) });
